var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#FFEBEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5001 24.6667C24.7887 24.6667 25.8334 23.622 25.8334 22.3333C25.8334 21.0447 24.7887 20 23.5001 20C22.2114 20 21.1667 21.0447 21.1667 22.3333C21.1667 23.622 22.2114 24.6667 23.5001 24.6667Z",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1666 15.3333H23.4999C17.6666 15.3333 15.3333 17.6666 15.3333 23.4999V30.4999C15.3333 36.3333 17.6666 38.6666 23.4999 38.6666H30.4999C36.3333 38.6666 38.6666 36.3333 38.6666 30.4999V24.6666",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22.3333V15.3333L36.3333 17.6666",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 15.3333L31.6667 17.6666",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.115 35.1083L21.8667 31.2467C22.7883 30.6283 24.1183 30.6983 24.9467 31.41L25.3317 31.7483C26.2417 32.53 27.7117 32.53 28.6217 31.7483L33.475 27.5833C34.385 26.8017 35.855 26.8017 36.765 27.5833L38.6667 29.2167",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallaryIcon);
export default __webpack_public_path__ + "static/media/gallaryIcon.1b76541baa75ab76d1a616a8c388548c.svg";
export { ForwardRef as ReactComponent };